var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Transform, Type } from "class-transformer";
import { IsArray, IsBoolean, IsEnum, IsInt, IsNotEmpty, IsNumber, IsOptional, IsString, Length, Matches, Max, MaxLength, Min, ValidateNested, } from "class-validator";
import { FASTEN_PLATFORM_CANONICAL_IDS } from "./fasten.platform.lookup";
export const FASTEN_SEARCH_DEFAULT_LIMIT = 20;
export const FASTEN_SEARCH_MAX_LIMIT = 100;
export const FASTEN_SEARCH_MAX_OFFSET = 1000;
export const FASTEN_SEARCH_ZIPCODE_REGEX = /^\d{5}$/;
const FASTEN_SEARCH_TIERS = [1, 2, 3, 4];
const FASTEN_SEARCH_MATCHED_VIA = ["name", "alias", "platformType"];
const FASTEN_SEARCH_MODES = ["name", "platformType"];
const FASTEN_SEARCH_DISPLAY_LOCATION_KINDS = ["single", "summary", "many"];
export class FastenSearchInputDto {
}
__decorate([
    IsString(),
    IsNotEmpty(),
    MaxLength(200)
], FastenSearchInputDto.prototype, "query", void 0);
__decorate([
    IsOptional(),
    IsString(),
    Matches(FASTEN_SEARCH_ZIPCODE_REGEX, { message: "zipcode must be 5 digits" })
], FastenSearchInputDto.prototype, "zipcode", void 0);
__decorate([
    IsOptional(),
    IsString(),
    MaxLength(100)
], FastenSearchInputDto.prototype, "city", void 0);
__decorate([
    IsOptional(),
    IsString(),
    Length(2, 2),
    Matches(/^[A-Za-z]{2}$/, { message: "state must be a 2-letter code" })
], FastenSearchInputDto.prototype, "state", void 0);
__decorate([
    IsOptional(),
    Transform(({ value }) => (typeof value === "string" ? value.toLowerCase() : value)),
    IsEnum(FASTEN_PLATFORM_CANONICAL_IDS, {
        message: "platformType must be a valid Fasten platform canonical id",
    })
], FastenSearchInputDto.prototype, "platformType", void 0);
__decorate([
    IsOptional(),
    IsBoolean()
], FastenSearchInputDto.prototype, "isSandbox", void 0);
__decorate([
    IsOptional(),
    IsInt(),
    Min(1),
    Max(FASTEN_SEARCH_MAX_LIMIT)
], FastenSearchInputDto.prototype, "limit", void 0);
__decorate([
    IsOptional(),
    IsInt(),
    Min(0),
    Max(FASTEN_SEARCH_MAX_OFFSET)
], FastenSearchInputDto.prototype, "offset", void 0);
__decorate([
    IsOptional(),
    IsString(),
    IsNotEmpty()
], FastenSearchInputDto.prototype, "batchId", void 0);
export class FastenSearchEndpointDto {
}
__decorate([
    IsString()
], FastenSearchEndpointDto.prototype, "id", void 0);
__decorate([
    IsString()
], FastenSearchEndpointDto.prototype, "platformType", void 0);
export class FastenSearchPortalDto {
}
__decorate([
    IsString()
], FastenSearchPortalDto.prototype, "id", void 0);
__decorate([
    IsString()
], FastenSearchPortalDto.prototype, "name", void 0);
__decorate([
    IsOptional(),
    IsString()
], FastenSearchPortalDto.prototype, "portalWebsite", void 0);
__decorate([
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => FastenSearchEndpointDto)
], FastenSearchPortalDto.prototype, "endpoints", void 0);
__decorate([
    IsOptional(),
    IsBoolean()
], FastenSearchPortalDto.prototype, "alreadyAdded", void 0);
__decorate([
    IsOptional(),
    IsString()
], FastenSearchPortalDto.prototype, "addedAt", void 0);
export class FastenSearchDisplayLocationDto {
}
__decorate([
    IsEnum(FASTEN_SEARCH_DISPLAY_LOCATION_KINDS)
], FastenSearchDisplayLocationDto.prototype, "kind", void 0);
__decorate([
    IsOptional(),
    IsString(),
    MaxLength(100)
], FastenSearchDisplayLocationDto.prototype, "city", void 0);
__decorate([
    IsOptional(),
    IsString(),
    Length(2, 2)
], FastenSearchDisplayLocationDto.prototype, "state", void 0);
__decorate([
    IsOptional(),
    IsInt(),
    Min(1)
], FastenSearchDisplayLocationDto.prototype, "totalCount", void 0);
__decorate([
    IsOptional(),
    IsArray(),
    IsString({ each: true })
], FastenSearchDisplayLocationDto.prototype, "stateCodes", void 0);
export class FastenSearchResultDto {
}
__decorate([
    IsString()
], FastenSearchResultDto.prototype, "id", void 0);
__decorate([
    IsString()
], FastenSearchResultDto.prototype, "name", void 0);
__decorate([
    IsEnum(FASTEN_SEARCH_MATCHED_VIA)
], FastenSearchResultDto.prototype, "matchedVia", void 0);
__decorate([
    IsOptional(),
    IsString()
], FastenSearchResultDto.prototype, "matchedAlias", void 0);
__decorate([
    IsEnum(FASTEN_SEARCH_TIERS)
], FastenSearchResultDto.prototype, "tier", void 0);
__decorate([
    IsNumber()
], FastenSearchResultDto.prototype, "score", void 0);
__decorate([
    IsBoolean()
], FastenSearchResultDto.prototype, "isSandbox", void 0);
__decorate([
    IsOptional(),
    ValidateNested(),
    Type(() => FastenSearchDisplayLocationDto)
], FastenSearchResultDto.prototype, "displayLocation", void 0);
__decorate([
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => FastenSearchPortalDto)
], FastenSearchResultDto.prototype, "portals", void 0);
export class FastenSearchResponseDto {
}
__decorate([
    IsInt()
], FastenSearchResponseDto.prototype, "totalHits", void 0);
__decorate([
    IsInt()
], FastenSearchResponseDto.prototype, "offset", void 0);
__decorate([
    IsInt()
], FastenSearchResponseDto.prototype, "limit", void 0);
__decorate([
    IsBoolean()
], FastenSearchResponseDto.prototype, "hasMore", void 0);
__decorate([
    IsEnum(FASTEN_SEARCH_MODES)
], FastenSearchResponseDto.prototype, "searchMode", void 0);
__decorate([
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => FastenSearchResultDto)
], FastenSearchResponseDto.prototype, "results", void 0);
export class FastenSearchReindexResponseDto {
}
__decorate([
    IsBoolean()
], FastenSearchReindexResponseDto.prototype, "started", void 0);
